import classNames from "classnames"

export const Unfound = () => {
    return (
        <div className={classNames("full-v","flx-cnt-pg")}>
            <h1>404</h1>
            <h1>Page not found!</h1>
        </div>
    )
}